<template>
  <div>
    <nav-bar/>
    <div class="zones-containor">
      <div class="map-div">
        <gmap-map id="map" :zoom="8" :center="center"></gmap-map>
      </div>
      <button
        class="btn btn-kne-orange w-100 mobile-toggle"
        v-show="true"
        @click="showList = !showList"
      >
        {{ showList ? $t('Zones.hide') : $t('Zones.show_all_zones') }}
      </button>
      <div class="zones-list-div" v-show="showList">
        <zone-pricing-modal v-if="showModal" :zone="zone" :allowActions="true" @closeModal="closeModal"></zone-pricing-modal>
        <div v-if="showWarning" style="text-align: center; color: #f00;">{{$t('Zones.user_restriction_message')}}</div>
        <button v-if="!showAdd && !showEdit" class="btn btn-kne-orange w-100" @click="addPolygon">{{$t('Zones.add_new_zone')}}</button>
        <div v-if="!showAll && zones.length">
          <button v-on:click="showAll = !showAll" class="btn btn-kne-orange w-100 shw-btn m-b-8">{{$t('Zones.show_all_zones')}}</button>
        </div>
        <div v-if="showAll && zones.length">
          <button v-on:click="showAll = !showAll" class="btn w-100 btn-blk shw-btn m-b-8">{{$t('Zones.hide')}}</button>
        </div>
        <regular-input v-if="showAdd" min="0" :value="areaName" @input="areaName = $event" type="text" :placeholder="$t('Zones.zone_name')"/>
        <div class="btns-cont">
          <button v-if="showAdd" class="btn btn-kne-orange w-45" @click="addZone()">{{$t('Zones.save')}}</button>
          <button v-if="showAdd" class="btn w-45 btn-blk btn-cnl" @click="cancelAdd()">{{$t('Zones.cancel')}}</button>
        </div>

        <regular-input v-if="showEdit" min="0" :value="zoneName" @input="zoneName = $event" type="text" />
        <div class="btns-cont">
          <button v-if="showEdit" class="btn btn-kne-orange w-45" @click="updateZone()">{{$t('Zones.save')}}</button>
          <button v-if="showEdit" class="btn w-45 btn-blk btn-cnl" @click="cancelEdit()">{{$t('Zones.cancel')}}</button>
        </div>

        <div style="display: flex;" class="m-b-8 pr-ctr" v-if="!showAdd && !showEdit && zones.length" >
          <button class="w-btn n-b-r" :class="{ 'active': operation === '+' }" @click="operation='+'">+</button>
          <button class="w-btn" :class="{ 'active': operation === '-' }" @click="operation='-'">-</button>
          <regular-input style="flex: 2;" min="0" :value="price" @input="price = $event" type="number" :placeholder="$t('Zones.price')"/>
          <button class="w-btn n-b-r" @click="updateAllZonesPrice(operation, '$')">$</button>
          <button class="w-btn" @click="updateAllZonesPrice(operation, '%')">%</button>
        </div>

        <div style="display: flex;" class="m-b-8 pr-ctr" v-if="!showAdd && !showEdit && zones.length" >
          <input style="flex: 2" class="search-inp form-control" type="text"  @input="onSearchInput($event)" @keyup.enter="filterZones()" :placeholder="$t('Zones.search')"/>
          <button  class="w-btn" @click="filterZones()" id="search-btn">
            <i class="fa fa-search" />
          </button>
        </div>

        <div class="selectall-ctr" v-if="!showAdd && !showEdit && zones.length">
          <input type="checkbox" id="selectAll" @change="selectAllZones($event.target.checked)">
          <h1>{{$t('Zones.select_all')}}</h1>
        </div>

        <div class="zones-div">
        <div v-if="!showAdd && !showEdit" v-for="(zone, index) in filteredZones" :key="zone.id">
          <div class="zone-div">
            <input type="checkbox" :key="zone.id" name="options" :id="zone.id" v-model="selectedZones[zone.id]" :checked="selectedZones[zone.id]">
            <h1 class="zone-name" @click="openModal(zone)">{{ zone.zoneName }}</h1>
            <hover-tool-tip
                  :text="zone.zoneName"
                  :clickable="true"
             />
            <div class="zone-btns-cont">
              <button class="btn-view" @click="showPolygon(zone)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="svg-icn">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
              </button>
              <button class="btn-edit" @click="editPolygon(zone)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                  stroke="currentColor" class="svg-icn">
                  <path stroke-linecap="round" stroke-linejoin="round"
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
                </svg>
              </button>
              <button class="btn-del" @click="deleteZone(zone.id)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="svg-icn">
                  <path fill-rule="evenodd"
                    d="M2.515 10.674a1.875 1.875 0 0 0 0 2.652L8.89 19.7c.352.351.829.549 1.326.549H19.5a3 3 0 0 0 3-3V6.75a3 3 0 0 0-3-3h-9.284c-.497 0-.974.198-1.326.55l-6.375 6.374ZM12.53 9.22a.75.75 0 1 0-1.06 1.06L13.19 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06l1.72-1.72 1.72 1.72a.75.75 0 1 0 1.06-1.06L15.31 12l1.72-1.72a.75.75 0 1 0-1.06-1.06l-1.72 1.72-1.72-1.72Z"
                    clip-rule="evenodd" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      </div>
    </div>
  </div>
</template>

<script>
import { db, firebase } from '../../firebase'
import { gmapApi } from 'vue2-google-maps'
import * as turf from '@turf/turf'
import RegularInput from '../module/basic-components/regularInput'
import ZonePricingModal from '../module/special-components/Modal-templates/ZonePricing-modal.vue'
import HoverToolTip from '../module/basic-components/hoverToolTip.vue'

export default {
  name: 'Settings',
  components: {
    RegularInput,
    ZonePricingModal,
    HoverToolTip
  },

  data () {
    return {
      showWarning: false,
      showList: true,
      currentUser: null,
      usersOnPage: [],
      pageOwner: null,
      areaName: '',
      zones: [],
      map: null,
      drawingManager: null,
      newZoneCoordinates: [],
      center: {lat: 45.5374842, lng: -73.6034393},
      zone: null,
      zoneName: '',
      showAll: true,
      showAdd: false,
      showEdit: false,
      showModal: false,
      filteredZones: [],
      search: '',
      zoneNames: [],
      zoneIdToNameMap: {},
      selectedZones: {},
      price: '',
      operation: '+',
      activeUsers: {},
      joinedAt: new Date(),
      allowActions: false,
      activeUsersListener: null,
      activeUsersInterval: null,
      usStatesData: [],
      canadaProvincesData: [],
      presenceListener: null,
      ownerListener: null
    }
  },

  mounted () {
    this.initializeMap()
  },

  async created () {
  this.currentUser = firebase.auth().currentUser
  // Non-reactive on purpose (not in data): a reactive Firebase ref makes Vue observe the SDK cache
  this.presenceRef = db.ref(`database/zones/transporter/${this.companyUID}/activeUsers`)
  this.ownerRef = db.ref(`database/zones/transporter/${this.companyUID}/currentOwner`)
  await this.setupPresence()
  this.listenToPresence()
  this.listenToOwner()
  window.addEventListener('onbeforeunload', this.handleUnload)
  },

  methods: {
    async setupPresence () {
      const myPresenceRef = this.presenceRef.child(this.currentUser.uid)
      await myPresenceRef.set(true)
      myPresenceRef.onDisconnect().remove()
      this.checkAndSetOwner()
    },
    listenToPresence () {
      this.presenceListener = this.presenceRef.on('value', (snapshot) => {
        this.usersOnPage = Object.keys(snapshot.val() || {})
        this.updateWarning()
      })
    },
    listenToOwner () {
      this.ownerListener = this.ownerRef.on('value', (snapshot) => {
        if (snapshot.val()) {
          this.pageOwner = snapshot.val()
        } else {
          this.checkAndSetOwner()
        }
        this.updateWarning()
      })
    },
    removePresence () {
      if (this.presenceRef) {
        this.presenceRef.child(this.currentUser.uid).remove()
        this.presenceRef.off()
      }
      if (this.ownerRef) {
        this.ownerRef.off()
      }
      this.checkAndRemoveOwner()
    },
    async checkAndSetOwner () {
      const ownerSnapshot = await this.ownerRef.once('value')
      if (!ownerSnapshot.exists()) {
        await this.ownerRef.set(this.currentUser.uid)
      }
    },
    async checkAndRemoveOwner () {
      const ownerSnapshot = await this.ownerRef.once('value')
      if (ownerSnapshot.val() === this.currentUser.uid) {
        await this.ownerRef.remove()
      }
    },
    updateWarning () {
      this.showWarning = this.pageOwner !== null && this.pageOwner !== this.currentUser.uid
    },
    async handleUnload () {
      await this.removePresence()
    },
    async initializeMap () {
      await this.fetchGeoJsonData()
      await this.getZones()
      const polygonCenter = this.polygonCenter
      function getRandomColor () {
        let letters = '0123456789ABCDEF'
        let color = '#'
        for (let i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)]
        }
        return color
      }
      if (!this.google) {
        console.error('Google object is not defined yet.', this.google)
        setTimeout(this.initializeMap, 100)
        return
      }
      let mapOptions = {
        zoom: 10,
        mapTypeControl: false,
        streetViewControl: false,
        scaleControl: false,
        fullscreenControl: false,
        center: new this.google.maps.LatLng(45.5374842, -73.6034393)
      }
      let map = new this.google.maps.Map(document.getElementById('map'), mapOptions)
      this.map = map
      const trafficLayer = new this.google.maps.TrafficLayer()
      trafficLayer.setMap(map)
      this.drawingManager = new this.google.maps.drawing.DrawingManager({
        drawingMode: this.google.maps.drawing.OverlayType.POLYGON,
        drawingControl: true,
        drawingControlOptions: {
          position: this.google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [this.google.maps.drawing.OverlayType.POLYGON]
        },
        polygonOptions: {
          fillColor: '#BCDCF9',
          fillOpacity: 0.35,
          strokeWeight: 3,
          strokeColor: '#57ACF9',
          clickable: false,
          editable: true,
          zIndex: 1
        }
      })
      let google = this.google
      let zoneIdToNameMap = {}
      let zoneNames = []
      this.zones.forEach(function (element, index) {
        try {
          zoneNames.push(element.zoneName)
          zoneIdToNameMap[element.id] = element.zoneName
          element.coords = element.coordinates
        } catch (e) {
          return
        }
        let arry = []
        if (!Array.isArray(element.coordinates)) {
          return
        }
        element.coordinates.forEach(function (elem, idx) {
          if (elem[0] != null && elem[1] != null) {
            arry.push(new google.maps.LatLng(elem[1], elem[0]))
          }
        })
        if (arry != null) {
          element.coordinates = arry
        }
        const color = element.color ? element.color : getRandomColor()
        element.color = color
        let polygonObj = new google.maps.Polygon({
          paths: element.coordinates,
          strokeColor: color,
          strokeOpacity: 0.8,
          strokeWeight: 3,
          fillColor: color,
          fillOpacity: 0.60
        })
        element.polygon = polygonObj
        polygonObj.setMap(map)
        const polyCenter = polygonCenter(element.coords)
        let markerObj = new google.maps.Marker({
          position: polyCenter,
          label: { text: element.zoneName, color: 'black', fontSize: '18px', fontWeight: '400' },
          icon: {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 0
          }
        })
        markerObj.setMap(map)
        element.marker = markerObj
      })
      this.zoneNames = zoneNames
      this.zoneIdToNameMap = zoneIdToNameMap
      this.google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
        this.drawingManager.setDrawingMode(null)
        this.handlePolygonChange(polygon)
        this.google.maps.event.addListener(polygon.getPath(), 'set_at', () => {
          this.handlePolygonChange(polygon)
        })
        this.google.maps.event.addListener(polygon.getPath(), 'insert_at', () => {
          this.handlePolygonChange(polygon)
        })
        this.google.maps.event.addListener(polygon.getPath(), 'remove_at', () => {
          this.handlePolygonChange(polygon)
        })
      })
      this.filterZones()
    },
    handlePolygonChange (polygon) {
        let polygonArr = []
        for (let i = 0; i < polygon.getPath().getLength(); i++) {
          let point = [
            polygon.getPath().getAt(i).lng(),
            polygon.getPath().getAt(i).lat()
          ]
          polygonArr.push(point)
        }
        this.newZoneCoordinates = polygonArr
    },
    polygonCenter (poly) {
      let lats = poly.map((point) => point[1])
      let lngs = poly.map((point) => point[0])

      let lowx = Math.min(...lats)
      let highx = Math.max(...lats)
      let lowy = Math.min(...lngs)
      let highy = Math.max(...lngs)

      let centerX = lowx + (highx - lowx) / 2
      let centerY = lowy + (highy - lowy) / 2

      return { lat: centerX, lng: centerY }
    },
    polygonProvince (center) {
      const point = turf.point([center.lng, center.lat])
      for (const feature of this.canadaProvincesData.features) {
        if (turf.booleanPointInPolygon(point, feature)) {
          return feature.properties.name
        }
      }
      for (const feature of this.usStatesData.features) {
        if (turf.booleanPointInPolygon(point, feature)) {
          return feature.properties.name
        }
      }
      return null
    },
    checkPolygonIntersection (polygon1, polygon2) {
      const feature1 = turf.polygon(polygon1, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const feature2 = turf.polygon(polygon2, {
        crs: {
          type: 'name',
          properties: {
            name: 'WGS84'
          }
        }
      })
      const intersects = turf.booleanIntersects(feature1, feature2)
      return intersects
    },
    mapPolygons (polygon) {
      let arr = [[...polygon]]
      arr[0].push(arr[0][0])
      return arr
    },
    isZoneIntersecting (newZoneCoordinates, zones) {
      let intersecting = false
      zones.forEach((zone) => {
        if (this.zone && this.zone.id === zone.id) {
          return
        }
        if (this.checkPolygonIntersection(this.mapPolygons(newZoneCoordinates), this.mapPolygons(zone.coords))) {
          intersecting = true
          return
        }
      })
      return intersecting
    },
    addZone () {
      if (!this.areaName) {
        confirm('Please enter zone name before saving')
        return
      }
      if (this.zoneNames.includes(this.areaName)) {
        confirm('Zone name is already present. Please enter a different name.')
        return
      }
      if (!this.newZoneCoordinates || this.newZoneCoordinates.length === 0) {
        confirm('Please draw the polygon on map before saving')
        return
      }
      if (this.newZoneCoordinates.length < 3) {
        confirm('Please draw a proper polygon before saving')
        return
      }
      if (this.isZoneIntersecting(this.newZoneCoordinates, this.zones)) {
          alert('Zone intersecting with another')
          return
      }
      const center = this.polygonCenter(this.newZoneCoordinates)
      const point = [center.lat, center.lng]
      const province = this.polygonProvince(center)
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').push().set(
        {
          zoneName: this.areaName,
          coordinates: this.newZoneCoordinates,
          center: point,
          province
        }
      ).then(() => {
        console.log('Zone added')
        this.areaName = ''
        this.search = ''
        this.newZoneCoordinates = []
        this.showAdd = false
        this.initializeMap()
      }).catch(function (error) {
        console.error(error)
      })
    },
    updateZone () {
      if (!this.zoneName) {
        confirm('Please enter zone name before saving')
        return
      }
      if (this.zone.zoneName !== this.zoneName && this.zoneNames.includes(this.zoneName)) {
        confirm('Zone name is already present. Please enter a different name.')
        return
      }
      if (this.isZoneIntersecting(this.newZoneCoordinates, this.zones)) {
          alert('Zone intersecting with another')
          return
      }
      const center = this.polygonCenter(this.newZoneCoordinates)
      const point = [center.lat, center.lng]
      const province = this.polygonProvince(center)
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').child(this.zone.id).update(
        {
          zoneName: this.zoneName,
          coordinates: this.newZoneCoordinates,
          center: point,
          province
        }
      ).then(() => {
        console.log('Zone updated')
        this.showEdit = false
        this.newZoneCoordinates = []
        this.zone = {}
        this.search = ''
        this.initializeMap()
      }).catch(function (error) {
        console.error(error)
      })
    },
    async getZones () {
      if (!this.$store.state.zonesLoaded) {
        await this.$store.dispatch('subscribeToZones')
      }
      this.zones = this.$store.state.zones.map(zone => ({ ...zone }))
      return Promise.resolve()
    },
    showPolygon (zone) {
      zone.polygon.setMap(this.map)
      zone.marker.setMap(this.map)
      this.map.setCenter(this.polygonCenter(zone.coords))
      this.map.setZoom(10)
    },
    addPolygon () {
      this.showAdd = !this.showAdd
      this.drawingManager.setMap(this.map)
      console.log(1)
    },
    cancelAdd () {
      this.showAdd = false
      this.areaName = ''
      this.search = ''
      this.newZoneCoordinates = []
      this.selectAllZones(false)
      this.selectedZones = {}
      this.drawingManager.setMap(null)
      this.initializeMap()
    },
    editPolygon (zone) {
      this.showAdd = false
      this.showEdit = true
      this.zone = zone
      this.zoneName = zone.zoneName
      this.newZoneCoordinates = zone.coords
      zone.polygon.setEditable(true)
      zone.polygon.setDraggable(true)
      zone.polygon.setMap(this.map)
      this.map.setCenter(this.polygonCenter(zone.coords))
      this.map.setZoom(10)
      this.google.maps.event.addListener(zone.polygon.getPath(), 'set_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
      this.google.maps.event.addListener(zone.polygon.getPath(), 'insert_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
      this.google.maps.event.addListener(zone.polygon.getPath(), 'remove_at', () => {
        this.handlePolygonChange(zone.polygon)
      })
    },
    cancelEdit () {
      this.newZoneCoordinates = []
      this.zoneName = ''
      this.search = ''
      this.showEdit = false
      this.selectAllZones(false)
      this.selectedZones = {}
      this.initializeMap()
    },
    deleteZone (zone) {
      if (!confirm('Please confirm to delete zone')) {
        return
      }
      db.ref(`database/zones/transporter/${this.companyUID}/zone/${zone}`).remove()
          .then(() => {
            console.log('Zone deleted')
            this.initializeMap()
          })
          .catch(error => {
            console.error('Error deleting zone from Firebase:', error)
          })
    },
    openModal (zone) {
      this.zone = zone
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
      this.initializeMap()
    },
    updateAllZonesPrice (operation, unit) {
      if (!operation) {
        confirm('Please select operation')
        return
      }
      if (!unit) {
        confirm('Please select unit')
        return
      }
      if (!this.price) {
        confirm('Please enter price')
        return
      }
      let selectedZoneNames = []
      Object.entries(this.selectedZones).forEach(entry => {
        if (entry[1]) {
          selectedZoneNames.push(this.zoneIdToNameMap[entry[0]])
        }
      })
      if (selectedZoneNames.length === 0) {
        confirm('Please select zones')
        return
      }
      if (!confirm(`Please confirm to update price for zones - ${selectedZoneNames.join(', ')}`)) {
        return
      }
      db.ref('database/zones/transporter').child(this.companyUID).child('zone').once('value', (snapshot) => {
        let zoneNode = snapshot.val()
        Object.entries(zoneNode).forEach(key => {
          if (!this.selectedZones[key[0]]) {
            return
          }
          if (Object.entries(key[1]).length > 2) {
            Object.keys(key[1]).forEach(zoneInfo => {
              if (zoneInfo !== 'zoneName' && zoneInfo !== 'coordinates') {
                let existingPrice = key[1][zoneInfo].price
                if (existingPrice) {
                  let currentPrice = null
                  if (operation === '+') {
                    if (unit === '$') {
                      currentPrice = Number(existingPrice) + Number(this.price)
                    } else { // percentage
                      let num = Number(existingPrice) * Number(this.price) / 100
                      currentPrice = Number(existingPrice) + num
                      currentPrice = Math.ceil(currentPrice / 5) * 5
                    }
                  } else {
                    if (unit === '$') {
                      currentPrice = Number(existingPrice) - Number(this.price)
                    } else { // percentage
                      let num = Number(existingPrice) * Number(this.price) / 100
                      currentPrice = Number(existingPrice) - num
                    }
                  }
                  // update price in node
                  zoneNode[key[0]][zoneInfo]['price'] = currentPrice
                }
              }
            })
          }
        })
        // update in firebase db here
        db.ref('database/zones/transporter').child(this.companyUID).child('zone').update(
          zoneNode
        ).then(() => {
          document.getElementById('selectAll').checked = false
          this.selectAllZones(false)
          this.selectedZones = {}
          this.price = ''
          this.operation = '+'
          console.log('Zone pricing updated')
          this.initializeMap()
        }).catch(function (error) {
          console.error(error)
        })
      })
    },
    onSearchInput (event) {
      this.search = event.target.value
      if (this.search === '') {
        this.filterZones()
      }
    },
    filterZones () {
      if (!this.search) {
        this.filteredZones = this.zones
      }
      this.filteredZones = this.zones.filter(zone => zone.zoneName.toLowerCase().includes(this.search.toLowerCase()))
    },
    selectAllZones (checked) {
      const checkboxes = document.querySelectorAll('input[name="options"]')
      checkboxes.forEach(checkbox => {
        checkbox.checked = checked
        this.selectedZones[checkbox.id] = checked
      })
    },
    isPastDate (dateString) {
      const inputDate = new Date(dateString)
      const currentDate = new Date()
      if (isNaN(inputDate.getTime())) {
        return false
      }
      const timeDifference = currentDate.getTime() - inputDate.getTime()
      return timeDifference >= 7000
    },
    async fetchGeoJsonData () {
      try {
        const usResponse = await fetch('https://raw.githubusercontent.com/PublicaMundi/MappingAPI/master/data/geojson/us-states.json')
        this.usStatesData = await usResponse.json()
        const canadaResponse = await fetch('https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/canada.geojson')
        await canadaResponse.json().then((data) => {
          this.canadaProvincesData = data
        })
      } catch (error) {
        this.errorMessage = error.message
      }
    }
  },
  beforeDestroy () {
    this.removePresence()
    window.removeEventListener('onbeforeunload', this.handleUnload)
    if (this.presenceListener) {
      this.presenceRef.off('value', this.presenceListener)
    }
    if (this.ownerListener) {
      this.ownerRef.off('value', this.ownerListener)
    }
  },
  watch: {
    showAll (value) {
      if (value) {
        this.zones.forEach(zone => {
          zone.polygon.setMap(this.map)
          zone.marker.setMap(this.map)
        })
      } else {
        this.zones.forEach(zone => {
          zone.polygon.setMap(null)
          zone.marker.setMap(null)
        })
      }
    }
  },
  computed: {
    google: gmapApi,
    companyUID () {
      return this.$store.state.authorization.company
    },
    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>
<style>
.zones-containor {
  display: flex;
  padding: 10px;
  height: 90vh;
}
.map-div {
  flex: 2;
  height: 90vh;
  padding: 10px;
  min-width: 0;
}
#map {
  width:100%;
  height: 100%;
}
.btn-kne-orange {
  margin-top: 5px;
  margin-bottom: 5px;
}
.btns-cont {
  display: flex;
  justify-content: space-between;
}
.zones-list-div {
  margin: 5px;
  padding: 10px;
  width: 300px;
  border: gray 1px;
  height: 80vh;
}
.zone-name {
  text-transform: capitalize;
  font-size: 15px;
  margin: auto 2px;
  cursor: pointer;
  margin-left: 5px;
  margin-right: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.svg-icn {
  width: 1rem;
  vertical-align: middle;
}
.w-45 {
  margin-top: 8px;
  width: 47%;
}
.btn-blk {
  background: black;
  color: white;
}
.shw-btn {
  margin-top: 2px;
}
.btn-cnl {
  margin-bottom: 5px;
}
.zones-div {
  height: calc(80vh - 166px);
  overflow-y: scroll;
}
.zone-div {
  display: flex;
  align-items: center;
  justify-content:
  space-between; padding: 1px;
  border-radius: 4px;
  border: 1px solid #ddd;
  margin-bottom: 8px;
}
.zone-div svg {
  padding-bottom: 2px;
}
.zone-btns-cont {
  display: flex;
  align-items: center;
  gap: 2px;
}
.btn-view {
  border: 1px solid #1ea7fd;
  border-radius: 4px;
  color: #1ea7fd;
  background-color: transparent;
  cursor: pointer;
}
.btn-edit {
  border: 1px solid #4ade80;
  border-radius: 4px;
  color: #4ade80;
  background-color: transparent;
  cursor: pointer;
}
.btn-del {
  border: 1px solid #f00;
  border-radius: 4px;
  color: #f00;
  background-color: transparent;
  cursor: pointer;
}
.m-b-8 {
  margin-bottom: 8px;
}
.pr-ctr {
  height: 30px;
}
.pr-ctr input {
  height: 30px;
}
.pr-ctr input:disabled {
  background-color: #fff;
}
.w-btn {
  width: 30px;
  background-color: white;
  border: 1px solid #ddd;
}
.w-btn:focus {
  outline: none;
}
.n-b-r {
  border-right: none !important;
}
.active {
  background-color: #f7941e;
  color: white;
}
.zone-div > input {
  min-width: 18px;
  height: 18px;
}
.zone-div #hoverIcon {
  margin-right: 1px;
}
.selectall-ctr {
  display: flex;
  margin-top: 15px;
  margin-bottom: 8px;
}
.selectall-ctr input {
  width: 18px;
  height: 18px;
}
.selectall-ctr h1 {
  font-size: 16px;
  margin: auto 8px;
}
.search-inp, .search-inp:focus, .search-inp:active {
  border: 1px solid #ddd !important;
}
.fa-search {
  font-size: 85%;
}
.zones-div .icon--tooltip {
    min-width: 210px !important;
    left: -550%
}
.mobile-toggle {
  display: none;
}
@media (max-width: 768px) {
  .zones-containor {
    flex-direction: column;
    align-items: stretch;
    height: auto; /* let height be natural or controlled per element */
  }

  /* Map should occupy full width and be taller for drawing */
  .map-div {
    flex: 0 0 auto;
    width: 100%;
    padding: 6px;
    height: 60vh; /* big canvas for drawing zones */
  }

  /* the list goes below the map and becomes a panel */
  .zones-list-div {
    width: 100%;
    height: calc(40vh - 20px); /* smaller panel to allow map to be primary */
    overflow-y: auto;
    margin-top: 6px;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #eee;
    display: block; /* v-show will handle visibility */
  }

  /* hide the default show/hide desktop buttons if any */
  .shw-btn { display: none; }

  /* Mobile toggle button visible on small screens */
  .mobile-toggle {
    display: block;
    margin-bottom: 8px;
    width: 100%;
    box-sizing: border-box;
  }

  /* if you want the list collapsed by default, use this class (optional) */
  .zones-list-div.collapsed {
    display: none;
  }
}

/* Extra small phones: make map even taller */
@media (max-width: 440px) {
  .map-div {
    height: 66vh;
  }
  .zones-list-div {
    height: calc(34vh - 20px);
  }
}
</style>
